import HintWindow from './HintWindow';

export default HintWindow;